"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[877],{

/***/ 20877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "WindowQueryParams": function() { return /* binding */ WindowQueryParams; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(64297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(58408);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/DomainError.ts
var DomainError = __webpack_require__(11455);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/ErrorsCode.ts
var ErrorsCode = __webpack_require__(65694);
;// CONCATENATED MODULE: ../../packages/stayforlong/src/_queryparams/QueryParams.ts





var defaultOptions = {
    required: true,
    caseSensitive: true
};
function createCaseInsensitiveParams(originalParams) {
    var newParams = new URLSearchParams();
    Array.from(originalParams.entries()).forEach(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        newParams.set(key.toLowerCase(), value);
    });
    return newParams;
}
var QueryParams = /*#__PURE__*/ function() {
    "use strict";
    function QueryParams() {
        (0,_class_call_check/* default */.Z)(this, QueryParams);
    }
    var _proto = QueryParams.prototype;
    _proto.getByQuery = function getByQuery(param) {
        var query = param.query, options = param.options;
        var mergedOptions = (0,_object_spread/* default */.Z)({}, defaultOptions, options);
        var URLSearchParams1 = this.searchParams();
        var value = URLSearchParams1.get(query);
        if (!mergedOptions.caseSensitive) {
            URLSearchParams1 = createCaseInsensitiveParams(URLSearchParams1);
            value = URLSearchParams1.get(query.toLowerCase());
        }
        if (mergedOptions.required && !value) {
            return [
                DomainError/* DomainError.withCodes */.Z.withCodes(ErrorsCode/* ErrorsCode.MISSING_QUERY_PARAM */.v.MISSING_QUERY_PARAM),
                undefined
            ];
        }
        return [
            undefined,
            value
        ];
    };
    return QueryParams;
}();

;// CONCATENATED MODULE: ../../packages/stayforlong/src/_queryparams/WindowQueryParams.ts




var WindowQueryParams = /*#__PURE__*/ function(QueryParams) {
    "use strict";
    (0,_inherits/* default */.Z)(WindowQueryParams, QueryParams);
    var _super = (0,_create_super/* default */.Z)(WindowQueryParams);
    function WindowQueryParams(config) {
        (0,_class_call_check/* default */.Z)(this, WindowQueryParams);
        var _this;
        _this = _super.call(this);
        _this.config = config;
        return _this;
    }
    var _proto = WindowQueryParams.prototype;
    _proto.searchParams = function searchParams() {
        return new URLSearchParams(window.location.search);
    };
    WindowQueryParams.create = function create(param) {
        var config = param.config;
        return new WindowQueryParams(config);
    };
    return WindowQueryParams;
}(QueryParams);


/***/ })

}]);